
export const PROJECT_DETAILS_PARAMETERS_ACTIVATE = 'PROJECT_DETAILS_PARAMETERS_ACTIVATE';
export const PROJECT_DETAILS_PARAMETERS_DEACTIVATE = 'PROJECT_DETAILS_PARAMETERS_DEACTIVATE';



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/project-details/actions/parameters.ts